import { createSlice } from "@reduxjs/toolkit";

const usersDefaultColumns = [
  "NAME",
  "EMAIL",
  "ROLE",
  "COMPANY",
  "PARTNER",
  "LAST LOGIN",
  "JOINED",
  "STATUS",
];

const initialState = {
  groups: [],

  user: null,
  users: { count: 0, results: [] },
  usersParams: { limit: 10, offset: 0 },
  usersLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: usersDefaultColumns,
      allViews: { "Default View": usersDefaultColumns },
      nameOfViews: [],
    },
  },

  userSelect: null,
  usersSelect: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    getUsers: (state, action) => {
      state.users = action.payload;
    },
    resetUsers: state => {
      state.users = [];
    },
    resetUserSelect: state => {
      state.userSelect = initialState.userSelect;
    },
    resetUsersParams: state => {
      state.usersParams = { limit: state.usersParams.limit, offset: 0 };
    },
    resetUsersSelect: state => {
      state.usersSelect = initialState.usersSelect;
    },
    setGroups: (state, action) => {
      state.groups = action.payload;
    },
    setUserSelect: (state, action) => {
      state.userSelect = action.payload;
    },
    setUsersParams: (state, action) => {
      state.usersParams = action.payload;
    },
    setUsersSelect: (state, action) => {
      state.usersSelect = action.payload;
    },
    updateUsersParams: (state, action) => {
      state.usersParams = { ...state.usersParams, ...action.payload };
    },
    updateUserStatus: (state, action) => {
      const results = state.users?.results;
      if (!Array.isArray(results)) return;
      const index = results.findIndex(
        user => user.id === action.payload.id && user.row_kind !== "invitation",
      );
      if (index !== -1) {
        const isActive =
          action.payload.is_active !== undefined
            ? action.payload.is_active
            : !results[index].is_active;
        results[index] = {
          ...results[index],
          is_active: isActive,
          status: isActive ? "Active" : "Inactive",
        };
      }
    },
    setUsersLayoutAllViews: (state, action) => {
      state.usersLayout = {
        ...state.usersLayout,
        completeListOfViews: action.payload || [],
      };
    },
  },
});

export const {
  getUsers,
  resetUsers,
  resetUserSelect,
  resetUsersParams,
  resetUsersSelect,
  setGroups,
  setUserSelect,
  setUsersParams,
  setUsersSelect,
  setUsersLayoutAllViews,
  updateUsersParams,
  updateUserStatus,
} = userSlice.actions;

export default userSlice.reducer;

export const users = state => state.user.users;
